"use client";
import {
  AlertOctagon,
  AlertTriangle,
  ShieldCheck,
} from "lucide-react";
import {
  type ScanReport,
} from "../../lib/types";


export function verdictTone(verdict: ScanReport["verdict"]) {
  if (verdict === "Malicious") return "critical";
  if (verdict === "High risk") return "high";
  if (verdict === "Suspicious") return "medium";
  if (verdict === "Low risk") return "low";
  return "safe";
}

/**
 * The banner icon follows the verdict, never the raw score.
 *
 * This used to restate the numeric band thresholds (>= 60, >= 30) to choose an
 * icon, which made the interface a second owner of the risk model: move a band
 * in `scoring.ts` and the icon would keep the old ladder while the headline
 * changed. Deriving from the verdict keeps one owner. The mapping is identical
 * to the bands it replaces -- Malicious and High risk both read as the octagon,
 * Suspicious as the triangle.
 */

export function verdictIcon(verdict: ScanReport["verdict"]) {
  const tone = verdictTone(verdict);
  if (tone === "critical" || tone === "high") return <AlertOctagon size={25} />;
  if (tone === "medium") return <AlertTriangle size={25} />;
  return <ShieldCheck size={25} />;
}


export function verdictCopy(report: ScanReport) {
  if (report.verdict === "Malicious")
    return "Multiple high-confidence behaviors strongly match a hostile package. Keep this sample quarantined.";
  if (report.verdict === "High risk")
    return "Strong risky behaviors require manual validation before this package is allowed to run.";
  if (report.verdict === "Suspicious")
    return "The sample contains behavior that is not automatically malicious, but deserves targeted review.";
  if (report.verdict === "Low risk")
    return "Only low-weight or contextual signals were found. Manual review is still recommended.";
  return "No obvious static indicators were found. This is not proof that the package is safe.";
}
